import { combineReducers } from 'redux';
import translationsReducer from './translationsReducer';
import { showTemporaryRankReducer, horseOnAirReducer } from './collectionReducer';

const rootReducer = combineReducers({
  translations: translationsReducer,
  showTemporaryRank: showTemporaryRankReducer,
  horseOnAir: horseOnAirReducer,
});

export default rootReducer;
